var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinesinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 96"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#Lines_inline_svg__a)",
  d: "M1 -3.33595e-07L1.00419 96M7.9979 -1.66889e-07C7.99954 37.4903 8.00046 58.5097 8.00209 96M14.9958 -1.83087e-10L15 96"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Lines_inline_svg__a",
  x1: 8,
  x2: 8,
  y1: 0,
  y2: 304.133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.034,
  stopColor: "#FBFAF6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.269,
  stopColor: "#00B684"
})))));
export default SvgLinesinline;